import './iscroll-zoom.js'
import { initSwipeEvents, enableSwiping, disableSwiping } from './CciSwipeEvents.js'
import CciArticleLayer from './layers/CciArticleLayer.vue'
import CciClickableAdLayer from './layers/CciClickableAdLayer.vue'
import CciWidgetLayer from './layers/CciWidgetLayer.vue'
import CciZoomAreaLayer from './layers/CciZoomAreaLayer.vue'
import Cropper from 'cropperjs'
// import { CciDataSourceUpdatePages, CciDataSourceClearMemory, pages } from 'model/CciDataSource.js'
// import {Spinner} from 'spin.js'
// import '../../../node_modules/spin.js/spin.css'

/* eslint-disable no-unused-vars */

import {
  mapGetters
} from 'vuex'

export default {
  props: ['pageId', 'pageHeight'],
  data () {
    return {
      zoomer: null,
      doubleClickZoomLevel: 1.0,
      clickCount: 0,
      clickTimer: null,
      leftPage: null,
      rightPage: null,
      leftArticles: [],
      rightArticles: [],
      leftClickableAds: [],
      rightClickableAds: [],
      leftWidgets: [],
      rightWidgets: [],
      leftZoomObjects: [],
      rightZoomObjects: [],
      cropper: undefined,
      cropperOnScreen: false,
      cropperIsMoving: false,
      leftThumbPageIsLoaded: false,
      rightThumbPageIsLoaded: false,
      initPage: null,
      page: undefined,
      trackAnimateZoomEvent: '',
      shouldScrollToRight: false
    }
  },
  created () {
    window.addEventListener('mi_micb_loaded', this.fireInitPageTrackingEvent, false)
    window.addEventListener('buttonZoomIn', this.zoomInFromButton, false)
    window.addEventListener('buttonZoomOut', this.zoomOutFromButton, false)

    document.addEventListener('fullscreenchange', this.fullscreenChange, false)
    document.addEventListener('mozfullscreenchange', this.fullscreenChange, false)
    document.addEventListener('webkitfullscreenchange', this.fullscreenChange, false)
    document.addEventListener('msfullscreenchange', this.fullscreenChange, false)

    // window.addEventListener('resize', this.didPageResize)
  },
  mounted () {
    this.page = this.getPageFromId()
    this.applySettings(this.settings)
    // if (this.page.firstPage.id === this.currentPage.firstPage.id) {
      // this page slide is the first page that is shown when loading the web reader.
    this.initPage = this.page
      // load the thumbnail(s).
    this.loadThumbnails()
    if (!this.initPageLoaded) {
      // Scroll previous page to the right at init.
      let currentPageIndex = this.pages.indexOf(this.currentPage)
      let pageIndex = this.pages.indexOf(this.page)
      let isPrevPage = pageIndex == currentPageIndex - 1
      if (isPrevPage) {
        this.shouldScrollToRight = true
      }
    }
  },
  computed: {
    ...mapGetters({
      opsUrl: 'getOpsUrl',
      showOverlay: 'getShowOverlay',
      currentPage: 'getCurrentPage',
      pages: 'getPages',
      singlePagesNoAds: 'getSinglePagesNoAds',
      sections: 'getSections',
      settings: 'getSettings',
      maxZoom: 'getMaxZoom',
      isZoomAnimating: 'getIsZoomAnimating',
      adsEnabled: 'getAdsEnabled',
      showCrop: 'getShowCrop',
      isFullPageViewMode: 'getPageViewMode',
      initPageLoaded: 'getInitPageLoaded'
    })
  },
  watch: {
    settings: function (newValue) {
      this.applySettings(newValue)
    },
    pageHeight: function (newValue) {
      if (this.page !== undefined && this.isPhone()) {
        if (newValue !== '') {
          var pageElem = document.getElementById(this._uid + 'page-left')
          var pageCont = document.getElementById(this._uid + 'page-left-container')
          pageElem.style.height = newValue
          pageCont.style.height = newValue
        }
      } else if (this.page !== undefined) {
        this.layoutPages()
      }
    },
    currentPage: function (newValue) {
      if (this.page !== newValue && this.settings.resetZoomOnPageChange  && this.zoomer !== null && this.zoomer.scale > 1.0 && this.isFullPageViewMode) {
        this.zoomToLevel(1.0)
      }
      if (this.page === newValue && this.leftPage !== null && !this.leftThumbPageIsLoaded && !this.rightThumbPageIsLoaded) {
        this.leftPage = null
        this.rightPage = null
        this.loadThumbnails()
      } else if (this.page === newValue && this.leftPage !== null && this.leftPage.indexOf('background') === -1) {
        this.loadHighResPages()
      }
    },
    showCrop: function (newValue) {
      if (this.page !== this.currentPage || this.currentPage.firstPage.interstitialAdAfterPage !== undefined) {
        return
      }
      this.destroyCropper()
      disableSwiping()

      if (this.zoomer.scale > 1.0) {
        this.zoomToLevel(1.0, 0, 0)
      }
      if (newValue === true || this.currentPage.secondPage || !this.cropperOnScreen) {
        let pageSide = this.$store.state.pageSide
        var pageImage = document.getElementById(this._uid + 'page-left')
        var cropPage = this.currentPage.firstPage
        if (pageSide !== undefined && pageSide === 1) {
          pageImage = document.getElementById(this._uid + 'page-right')
          cropPage = this.currentPage.secondPage
        }
        let cropActionDiv = document.createElement('div')
        cropActionDiv.id = 'crop-action'
        var cropButton = document.createElement('button')
        cropButton.id = 'crop-button'
        var cancelButton = document.createElement('button')
        cancelButton.id = 'cancel-button'

        var self = this
        // First we check if you support touch, otherwise it's click:
        let touchEvent = 'ontouchstart' in window ? 'touchstart' : 'click'
        cropButton.addEventListener(touchEvent, function (e) {
          self.$cciEventTrackingPlugin.trackEvent('ContextCropView', 'ActionCropOkButtonClick', cropPage, cropPage.attributes.Page)

          e.stopImmediatePropagation()
          e.preventDefault()
          let croppedImageCanvas = self.cropper.getCroppedCanvas()
          // As some browser doesn't DataURL to open in tab, i.e Chrome, needed to get from blob and
          // also not all browser has support for toBlob method
          let ua = window.navigator.userAgent
          let vendor = navigator.vendor
          let iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i)
          let webkit = !!ua.match(/WebKit/i)
          let iOSSafari = iOS && webkit && !ua.match(/CriOS/i) && !ua.match(/OPiOS/i) && !ua.match(/EdgiOS/i)
          let desktopSafari = /Safari/i.test(ua) && /Apple Computer/.test(vendor) && !/Mobi|Android/i.test(ua)
          let isIPadOsSafari = self.isTouchBrowser() && self.isSafari()
          if ((iOS || isIPadOsSafari) && !ua.match(/CriOS/i)) {
            let cropImg = croppedImageCanvas.toDataURL()
            let link = document.createElement('a')
            link.href = cropImg
            if (iOSSafari || isIPadOsSafari) {
              link.download = 'croppedImg.png'
            }
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          } else if (desktopSafari) {
            let windowReference = window.open()
            /* eslint-disable no-undef */
            croppedImageCanvas.toBlob(function (blob) {
              let imageUrl = URL.createObjectURL(blob)
              windowReference.location = imageUrl
            })
            /* eslint-enable no-undef */
          } else if (typeof croppedImageCanvas.toBlob !== 'undefined') {
            /* eslint-disable no-undef */
            croppedImageCanvas.toBlob(function (blob) {
              let imageUrl = URL.createObjectURL(blob)
              window.open(imageUrl, '_blank')
            })
            /* eslint-enable no-undef */
          } else {
            // if (!HTMLCanvasElement.prototype.toBlob) {
            //   Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
            //     value: function (callback, type, quality) {
            //       var canvas = this;
            //       setTimeout(function() {
            //         var binStr = atob( canvas.toDataURL(type, quality).split(',')[1] ),
            //           len = binStr.length,
            //           arr = new Uint8Array(len);
            //
            //         for (var i = 0; i < len; i++ ) {
            //           arr[i] = binStr.charCodeAt(i);
            //         }
            //
            //         callback( new Blob( [arr], {type: type || 'image/png'} ) );
            //       });
            //     }
            //   });
            // }
            let cropImgDataURL = croppedImageCanvas.toDataURL()
            let newWindow = window.open()
            newWindow.document.write('<img src="'+ cropImgDataURL + '"' + ' style="height: auto;' +
              '  max-width: 100%; display: block; margin: auto;" '+'/>')

          }
          if (self.cropper !== undefined) {
            self.destroyCropper()
            cropButton.removeEventListener(touchEvent)
          }
        })

        cancelButton.addEventListener(touchEvent, function (ev) {
          self.$cciEventTrackingPlugin.trackEvent('ContextCropView', 'ActionCropCancelButtonClick', cropPage, cropPage.attributes.Page)
          ev.stopImmediatePropagation()
          ev.preventDefault()
          self.destroyCropper()
          cancelButton.removeEventListener(touchEvent)
        })

        this.cropper = new Cropper(pageImage, {
          dragMode: 'none',
          zoomable: false,
          movable: false,
          cropmove: false,
          autoCropArea: 0.7,
          responsive: true,
          viewMode: 2,
          ready () {
            let cropperDiv = document.getElementsByClassName('cropper-container')[0]
            cropperDiv.style.zIndex = '50'
            let cropperBox = document.getElementsByClassName('cropper-crop-box')[0]
            cropActionDiv.appendChild(cropButton)
            cropActionDiv.appendChild(cancelButton)
            cropperBox.appendChild(cropActionDiv)
            self.cropperOnScreen = true
          }
        })
        pageImage.addEventListener('cropmove', (event) => {
          if (!this.cropperIsMoving) {
            this.cropperIsMoving = true
            // self.manageMouseWheelEventListeners(false)
            if (this.zoomer !== undefined || this.zoomer !== null) {
              this.zoomer.disable()
            }
          }
        })
        pageImage.addEventListener('cropend', (event) => {
          this.cropperIsMoving = false
          // self.manageMouseWheelEventListeners(true)
          if (this.zoomer !== undefined || this.zoomer !== null) {
            this.zoomer.enable()
          }
        })
      }
    }
  },
  methods: {
    applySettings (settings) {
      if (settings !== undefined) {
        if (!settings.enableZoom) {
          this.destroyZoomer()
        }
      }
    },
    pageImgLoaded (event) {
      var elm = event.target
      if (elm.src.indexOf('background') !== -1 && !this.initPageLoaded) {
        // If the high res is loaded and initial page is not yet loaded
        // -> send out a notification that the initial page is loaded.
        // We use this to wait with loading the ads until after the initial page has loaded.
        this.$store.commit('setInitPageLoaded', true)
      }

      if (elm.src.indexOf('thumbnail') !== -1) {
        // A thumbnail is loaded.
        if (elm.id === this._uid + 'page-left') {
          // Left thumbnail is loaded
          this.leftThumbPageIsLoaded = true
          if (this.page.secondPage === null) {
            // there is no second page so just set the right thumbnail as loaded.
            this.rightThumbPageIsLoaded = true
          }
        }

        if (elm.id === this._uid + 'page-right') {
          // Right thumbnail is loaded
          this.rightThumbPageIsLoaded = true
        }

        if (this.leftThumbPageIsLoaded && this.rightThumbPageIsLoaded) {
          // When all thumbnails are loaded -> initialize the zoomer and load the high res.
          this.initZoomer()
          if (this.page === this.currentPage) {
            this.loadHighResPages()
          }
        }
      }
    },
    loadThumbnails () {
      // load thumbnails unless it is an interstitial GPT ad.
      if (this.page.firstPage.interstitialAdAfterPage !== undefined) {
        return
      }
      if (this.leftPage === null || this.leftPage.indexOf('thumbnail') === -1) {
        document.getElementById(this._uid + 'page-left').src = this.getEncodedResourceUrl(this.page.firstPage.thumbnail, this.page.firstPage.attributes.LastRev)
        this.leftPage = this.getEncodedResourceUrl(this.page.firstPage.thumbnail, this.page.firstPage.attributes.LastRev)
      }
      if (this.page.secondPage !== null) {
        if (this.rightPage === null || this.rightPage.indexOf('thumbnail') === -1) {
          document.getElementById(this._uid + 'page-right').src = this.getEncodedResourceUrl(this.page.secondPage.thumbnail, this.page.secondPage.attributes.LastRev)
          this.rightPage = this.getEncodedResourceUrl(this.page.secondPage.thumbnail, this.page.secondPage.attributes.LastRev)
        }
      }
    },
    loadHighResPages () {
      this.loadLeftPage()
      this.loadRightPage()
      // Also load the page components (article, widget and clickable ad layers)
      this.loadPageComponents()
    },
    loadPageComponents () {
      this.loadLeftArticles()
      this.loadLeftClickableAds()
      this.loadLeftWidgets()
      this.loadLeftZoomObjects()

      this.loadRightArticles()
      this.loadRightClickableAds()
      this.loadRightWidgets()
      this.loadRightZoomObjects()
    },
    loadLeftPage() {
      if (this.page !== undefined) {
        var pageUrlToLoad
        if ((this.leftPage === null || this.leftPage.indexOf('background') === -1)) {
          pageUrlToLoad = this.getEncodedResourceUrl(this.page.firstPage.background, this.page.firstPage.attributes.LastRev)
        }

        if (this.page.firstPage.interstitialInfo !== null) {
          if (this.isPortrait()) {
            pageUrlToLoad = this.getEncodedResourceUrl(this.page.firstPage.interstitialInfo.portraitRef, this.page.firstPage.attributes.LastRev)
          } else {
            pageUrlToLoad = this.getEncodedResourceUrl(this.page.firstPage.interstitialInfo.landscapeRef, this.page.firstPage.attributes.LastRev)
          }
        }

        this.leftPage = pageUrlToLoad
        document.getElementById(this._uid + 'page-left').src = pageUrlToLoad
      }
    },
    loadRightPage() {
      if (this.page !== undefined) {
        if (this.page.secondPage !== null) {
          var pageUrlToLoad

          if ((this.rightPage === null || this.rightPage.indexOf('background') === -1)) {
            pageUrlToLoad = this.getEncodedResourceUrl(this.page.secondPage.background, this.page.secondPage.attributes.LastRev)
          }

          if (pageUrlToLoad !== undefined) {
            this.rightPage = pageUrlToLoad
            document.getElementById(this._uid + 'page-right').src = pageUrlToLoad
          }
        }
      }
    },
    loadLeftArticles() {
      var artArray = []
      if (this.page !== undefined) {
        for (var i = 0; i < this.page.firstPage.articles.length; i++) {
          var article = this.page.firstPage.articles[i]
          artArray.push(article)
        }
      }
      this.leftArticles = artArray
    },
    loadRightArticles() {
      var artArray = []
      if (this.page !== undefined) {
        if (this.page.secondPage !== null) {
          for (var j = 0; j < this.page.secondPage.articles.length; j++) {
            var article = this.page.secondPage.articles[j]
            artArray.push(article)
          }
        }
      }
      this.rightArticles = artArray
    },
    loadLeftWidgets() {
      var widgetArray = []
      if (this.page !== undefined) {
        for (var i = 0; i < this.page.firstPage.widgets.length; i++) {
          widgetArray.push(this.page.firstPage.widgets[i])
        }
      }
      this.leftWidgets = widgetArray
    },
    loadRightWidgets() {
      var widgetArray = []
      if (this.page !== undefined) {
        if (this.page.secondPage !== null) {
          for (var j = 0; j < this.page.secondPage.widgets.length; j++) {
            widgetArray.push(this.page.secondPage.widgets[j])
          }
        }
      }
      this.rightWidgets = widgetArray
    },
    loadLeftClickableAds () {
      var adArray = []
      if (this.page !== undefined) {
        if (this.page.firstPage.interstitialInfo !== null) {
          if (this.isPortrait()) {
            for (var j = 0; j < this.page.firstPage.interstitialInfo.portaitClickableAds.length; j++) {
              adArray.push(this.page.firstPage.interstitialInfo.portaitClickableAds[j])
            }
          } else {
            for (var k = 0; k < this.page.firstPage.interstitialInfo.landscapeClickableAds.length; k++) {
              adArray.push(this.page.firstPage.interstitialInfo.landscapeClickableAds[k])
            }
          }
        } else {
          for (var i = 0; i < this.page.firstPage.clickableAds.length; i++) {
            adArray.push(this.page.firstPage.clickableAds[i])
          }
        }
      }
      this.leftClickableAds = adArray
    },
    loadRightClickableAds () {
      var adArray = []
      if (this.page !== undefined) {
        if (this.page.secondPage !== null) {
          for (var j = 0; j < this.page.secondPage.clickableAds.length; j++) {
            adArray.push(this.page.secondPage.clickableAds[j])
          }
        }
      }
      this.rightClickableAds = adArray
    },
    loadLeftZoomObjects () {
      var zoomObjArray = []
      if (this.page !== undefined) {
        for (var i = 0; i < this.page.firstPage.zoomObjects.length; i++) {
          zoomObjArray.push(this.page.firstPage.zoomObjects[i])
        }
      }
      this.leftZoomObjects = zoomObjArray
    },
    loadRightZoomObjects () {
      var zoomObjArray = []
      if (this.page !== undefined && this.page.secondPage !== null) {
        for (var i = 0; i < this.page.secondPage.zoomObjects.length; i++) {
          zoomObjArray.push(this.page.secondPage.zoomObjects[i])
        }
      }
      this.rightZoomObjects = zoomObjArray
    },
    initZoomer () {
      if (this.zoomer !== null) {
        return
      }

      let zoomEL = document.getElementById(this._uid + 'page-wrapper')
      if (!zoomEL) {
        return
      }

      this.layoutPages()

      if (this.settings !== undefined && !this.settings.enableZoom) {
        return
      }

      if (!this.isDesktop()) {
        // We are only interested in swipe events on touch devices
        var pageContLeft = document.getElementById(this._uid + 'page-left-container')
        var pageContRight = document.getElementById(this._uid + 'page-right-container')
        initSwipeEvents(pageContLeft)
        initSwipeEvents(pageContRight)
      }

      if (this.page.firstPage.interstitialAdAfterPage !== undefined) {
        return
      }

      var maxZoom = 3
      if (this.maxZoom) {
        maxZoom = this.maxZoom
      }

      this.zoomer = new IScroll(zoomEL, {
        zoom: true,
        zoomMax: maxZoom,
        scrollY: true,
        scrollX: true,
        momentum: false,
        mouseWheel: true,
        HWCompositing: !this.isSafari(),
        click: false,
        tap: this.isTouchBrowser(),
        keyBindings: true,
        bounce: false,
        disablePointer: this.isTouchBrowser(),
        disableTouch: !this.isTouchBrowser()
      })

      if (this.isTouchBrowser()) {
        zoomEL.addEventListener('tap', this.onClickTap, false)
      }

      this.shouldScrollToRight ? this.scrollToRight(0) : this.scrollToLeft(0)

      if (!this.isFullPageViewMode) {
        this.resetZoomToFitWidth(true, 0)
      } else {
        if (this.adsEnabled && this.isDesktop()) {
          this.zoomer.wrapperOffset.left = -370
        } else if (this.isPhone()) {
          this.zoomer.wrapperOffset.left = -50
        } else {
          this.zoomer.wrapperOffset.left = -70
        }
      }

      this.zoomer.on('scrollStart', () => {
        this.$store.commit('setIsScrolling', true)
      })

      this.zoomer.on('scrollEnd', () => {
        setTimeout(this.scrollEnded, 500)
      })

      let self = this
      var prevScale = 1.0
      this.zoomer.on('trackpadZoomIn', () => {
        let roundedScale = Math.floor(self.zoomer.scale * 10) / 10
        if (roundedScale !== prevScale) {
          self.fireZoomEvent('ActionPagesPageZoomTrackpadPinchIn')
        }
        prevScale = roundedScale
      })
      this.zoomer.on('trackpadZoomOut', () => {
        let roundedScale = Math.floor(self.zoomer.scale * 10) / 10
        if (roundedScale !== prevScale) {
          self.fireZoomEvent('ActionPagesPageZoomTrackpadPinchOut')
        }
        prevScale = roundedScale
      })
      this.zoomer.on('touchZoomIn', () => {
        let roundedScale = Math.floor(self.zoomer.scale * 10) / 10
        if (roundedScale !== prevScale) {
          self.fireZoomEvent('ActionPagesPageZoomTouchPinchIn')
        }
        prevScale = roundedScale
      })
      this.zoomer.on('touchZoomOut', () => {
        let roundedScale = Math.floor(self.zoomer.scale * 10) / 10
        if (roundedScale !== prevScale) {
          self.fireZoomEvent('ActionPagesPageZoomTouchPinchOut')
        }
        prevScale = roundedScale
      })
    },
    resetZoomToFitWidth (init, centerY, centerX) {
      if (this.zoomer === null) return
      var yValue = 0
      if (centerY !== undefined) {
        yValue = centerY
      }

      var leftPageWidth = document.getElementById(this._uid + 'page-left-container').offsetWidth
      // if (this.page.firstPage.isSpread) {
      //   leftPageWidth = leftPageWidth / 2
      // }
      var pageWrapperWidth = document.getElementById(this._uid + 'page-wrapper').clientWidth
      let pageContainer = document.getElementById('pages-container')

      var scale = 1.0

      if (leftPageWidth > 0 && pageWrapperWidth > 0) {
        scale = pageWrapperWidth / leftPageWidth
        var xValue = pageContainer.clientWidth / 2
        if (centerX !== undefined) {
          xValue = centerX
        }
        if (this.isPhone()) {
          // if it is mobile sized -> offset by -50 (margin on left).
          this.zoomToLevel(scale, xValue, yValue, -50)
          // this.zoomer.wrapperOffset.left = -70
        } else if (init && this.adsEnabled && this.isDesktop()) {
          // This is the initial zoom when the zoomer is created. Also there are an ad on the left side.
          // the offset should be -370 but it is set to -70 when zooming... and then set to -370 for future zooming.
          // To be honest i don't know why we have to do this... But it works.
          this.zoomToLevel(scale, xValue, yValue, -70)
          this.zoomer.wrapperOffset.left = -370
        } else if (this.adsEnabled && this.isDesktop()) {
          this.zoomToLevel(scale, xValue, yValue, -370)
        } else {
          this.zoomToLevel(scale, xValue, yValue, -70)
        }

        this.doubleClickZoomLevel = scale
      }
    },
    scrollEnded () {
      this.$store.commit('setIsScrolling', false)
    },
    layoutPages () {
      if (this.page !== undefined) {
        var pagesCont = document.getElementById('pages-container')
        var pageElem1 = document.getElementById(this._uid + 'page-left')
        var pageCont1 = document.getElementById(this._uid + 'page-left-container')
        var pageElem2 = document.getElementById(this._uid + 'page-right')
        var pageCont2 = document.getElementById(this._uid + 'page-right-container')
        var zoomWrapper = document.getElementById(this._uid + 'zoom-wrapper')
        var pageWrapper = document.getElementById(this._uid + 'page-wrapper')
        if (pagesCont.style.height !== '') {
          pageElem1.style.height = pagesCont.style.height
          pageCont1.style.height = pagesCont.style.height
          if (this.page.secondPage !== null) {
            pageElem2.style.height = pagesCont.style.height
            pageCont2.style.height = pagesCont.style.height
          }
          zoomWrapper.style.height = pagesCont.style.height
          pageWrapper.style.height = pagesCont.style.height

          // Does the height fit the content? Or is the content stretched?
          let elemAspectRatio = (pageElem1.offsetWidth / pageElem1.offsetHeight).toFixed(2)

          let pageWrapperWidth = pageWrapper.offsetWidth
          let pageWrapperHeight = pageWrapper.offsetHeight

          let sectionModelWidth = this.page.firstPage.attributes.SectionModelPageWidth
          var objectWidth = this.page.firstPage.attributes.ObjectWidth
          var objectHeight = this.page.firstPage.attributes.ObjectHeight
          if (objectWidth >= sectionModelWidth * 2) {
            objectWidth = objectWidth / 2
          }

          let objectAspectRatio = (objectWidth / objectHeight).toFixed(2)

          if (pageWrapperWidth < pageElem1.offsetWidth) {
            // there is not enough space in width for the page.
            // We must reduce height until it fits.
            // It must follow the aspect ratio of the page json object.
            var fittedHeight = pageWrapperWidth / objectAspectRatio
            // let oldHeight = pageElem1.offsetHeight
            if (fittedHeight > pageWrapperHeight) {
              // Too high - reduce it.
              fittedHeight = pageWrapperHeight
            }

            pageElem1.style.height = fittedHeight + 'px'
            pageCont1.style.height = fittedHeight + 'px'
            if (this.page.secondPage !== null) {
              pageElem2.style.height = fittedHeight + 'px'
              pageCont2.style.height = fittedHeight + 'px'
            }

            if (zoomWrapper.offsetWidth < pageElem1.offsetWidth) {
              zoomWrapper.style.width = pageElem1.offsetWidth + 'px'
            }
          }
        }
        pageElem1.style.visibility = 'visible'
        if (this.page.secondPage !== null) {
          pageElem2.style.visibility = 'visible'
        }
      }
    },
    zoomAnimationDone () {
      // make it a one-shot handler, but cannot de-register while in callback
      this.$nextTick(() => {
        this.zoomer.off('scrollEnd', this.zoomAnimationDone)
      })
      // tracking module needs to know when we are done with the animation:
      this.$store.commit('setIsZoomAnimating', false)

      if (this.trackAnimateZoomEvent === 'ActionPagesPageZoomDoubleClickOut' ||
        this.trackAnimateZoomEvent === 'ActionPagesPageZoomDoubleClickIn' ||
        this.trackAnimateZoomEvent === 'ActionPagesPageZoomButtonClickIn' ||
        this.trackAnimateZoomEvent === 'ActionPagesPageZoomButtonClickOut') {
        this.fireZoomEvent('ActionPagesPageZoomDoubleClickOut')
        this.trackAnimateZoomEvent = ''
      }
    },
    zoomToLevel (zoomLevel, centerX, centerY, wrapperOffset) {
      if (zoomLevel > 1.0 && this.page.firstPage.id.indexOf('dummy') !== -1) {
        return
      }
      if (this.zoomer !== null && !this.isZoomAnimating) {
        this.$store.commit('setIsZoomAnimating', true)
        // NOTE: the IScroll module only sends 'scrollEnd' event when it's done animating
        this.zoomer.on('scrollEnd', this.zoomAnimationDone)
      }
      if (zoomLevel > 1.0) {
        if (this.zoomer !== null) {
          if (wrapperOffset !== undefined) {
            this.zoomer.wrapperOffset.left = wrapperOffset
          } else if (this.adsEnabled && this.isDesktop()) {
            // offset the zoom center point with the width of the left side ad and pageWrapper margin left.
            this.zoomer.wrapperOffset.left = -370
          } else if (this.isPhone()) {
            this.zoomer.wrapperOffset.left = -50
          } else {
            this.zoomer.wrapperOffset.left = -70
          }
          this.zoomer.zoom(zoomLevel, centerX, centerY)
        }
      } else {
        if (this.zoomer !== null) {
          this.zoomer.zoom(1)
        }
      }
    },
    sendClick (targetId) {
      /* Captured click was not a doubleclick, send a new click event to old target */
      /* eslint-disable no-undef */
      var event
      try {
        event = new MouseEvent('click', {
          view: window,
          bubbles: true,
          cancelable: true
        })
      } catch (e) {
        // Support for internet explorer...
        var mouseEvent = document.createEvent('MouseEvent')
        mouseEvent.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)

        mouseEvent.prototype = Event.prototype

        window.MouseEvent = mouseEvent
        event = mouseEvent
      }

      /* eslint-enable no-undef */
      const el = document.getElementById(targetId)
      if (el !== null) {
        el.dispatchEvent(event)
      }
    },
    onClick (event) {
      /* Take click events from children (see .capture above).
       *  Wait and see if it's a double click */
      if (event === undefined || !this.settings.enableZoom || this.settings.doubleClickZoomIncrease <= 0.0) {
        return // this click handler only handles doubleClick zoom
      }

      if (this.clickCount === 0 && this.clickTimer) {
        /* This an event we created in sendClick, skip it here */
        return
      }
      if (++this.clickCount === 1) {
        event.preventDefault()
        event.stopPropagation()
        let targetId = event.target.id
        this.clickTimer = setTimeout(() => {
          this.clickCount = 0
          this.sendClick(targetId)
          this.clickTimer = null
        }, 300)
      } else if (this.clickCount === 2) {
        event.stopPropagation()
        clearTimeout(this.clickTimer)
        this.clickTimer = null
        this.clickCount = 0
      }
    },
    onDoubleClick (event, touch) {
      if (this.page !== this.currentPage || this.page.firstPage.id.indexOf('dummy') !== -1) {
        return
      }
      if (!this.settings.enableZoom || this.settings.doubleClickZoomIncrease <= 0.0) {
        return // this double click handler only handles doubleClick zoom
      }
      let isTouch = touch !== undefined ? touch : false
      var yValue = event.clientY
      var xValue = event.clientX
      if (isTouch) {
        yValue = event.changedTouches[0].clientY
        xValue = event.changedTouches[0].clientX
      }
      let zoomLevel
      if (this.zoomer.scale > this.doubleClickZoomLevel && !this.isFullPageViewMode) {
        this.resetZoomToFitWidth(false, yValue, xValue)
        return
      } else if (this.isFullPageViewMode && this.zoomer.scale > 1.0) {
        this.trackAnimateZoomEvent = 'ActionPagesPageZoomDoubleClickOut'
        zoomLevel = 1.0
      } else {
        this.trackAnimateZoomEvent = 'ActionPagesPageZoomDoubleClickIn'
        zoomLevel = this.zoomer.scale + this.settings.doubleClickZoomIncrease
        if (zoomLevel > this.maxZoom) {
          zoomLevel = this.maxZoom
        }
      }

      if (zoomLevel === this.zoomer.scale) return
      this.zoomToLevel(zoomLevel, xValue, yValue)
    },
    onClickTap (event) {
      if (!this.settings.enableZoom || this.settings.doubleClickZoomIncrease <= 0.0) {
        return // this click handler only handles doubleClick zoom
      }

      if (this.clickCount === 0 && this.clickTimer) {
        /* This an event we created in sendClick, skip it here */
        return
      }
      if (++this.clickCount === 1) {
        event.preventDefault()
        event.stopPropagation()
        let targetId = event.target.id
        this.clickTimer = setTimeout(() => {
          this.clickCount = 0
          this.sendClick(targetId)
          this.clickTimer = null
        }, 300)
      } else if (this.clickCount === 2) {
        event.stopPropagation()
        clearTimeout(this.clickTimer)
        this.clickTimer = null
        this.clickCount = 0
      }
    },
    onTouchTap (event) {
      if (!this.settings.enableZoom || this.settings.doubleClickZoomIncrease <= 0.0 || !this.isTouchBrowser()) {
        return // this click handler only handles doubleClick zoom
      }

      if (this.clickCount === 0 && this.clickTimer) {
        /* This an event we created in sendClick, skip it here */
        return
      }
      if (++this.clickCount === 1) {
        event.preventDefault()
        event.stopPropagation()
        let targetId = event.target.id
        this.clickTimer = setTimeout(() => {
          this.clickCount = 0
          this.sendClick(targetId)
          this.clickTimer = null
        }, 300)
      } else if (this.clickCount === 2) {
        event.stopPropagation()
        clearTimeout(this.clickTimer)
        this.clickTimer = null
        this.clickCount = 0
        this.onDoubleClick(event, true)
      }
    },
    getArticleInCenter () {
      var centerArticleId = null
      if (!this.$refs.articles) return centerArticleId

      for (let article of this.$refs.articles) {
        if (article.getArticleIfInCenter() !== undefined) {
          centerArticleId = article.getArticleIfInCenter()
        }
      }
      return centerArticleId
    },
    getPageInCenter () {
      if (this.page.secondPage === null) {
        return this.page.firstPage
      }
      const leftPageDiv = document.getElementById(this._uid + 'page-left-container')
      const leftPageRect = leftPageDiv.getBoundingClientRect()
      const rightPageDiv = document.getElementById(this._uid + 'page-right-container')
      const rightPageRect = rightPageDiv.getBoundingClientRect()

      const windowWidth = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth
      const windowHeight = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight
      const centerX = windowWidth / 2
      const centerY = windowHeight / 2

      const isRightCenter = (
        rightPageRect.bottom >= centerY &&
        rightPageRect.top < centerY &&
        rightPageRect.left <= centerX &&
        rightPageRect.right > centerX
      )
      const isLeftCenter = (
        leftPageRect.bottom >= centerY &&
        leftPageRect.top < centerY &&
        leftPageRect.left <= centerX &&
        leftPageRect.right > centerX
      )
      if (isLeftCenter) {
        return this.page.firstPage
      } else if (isRightCenter) {
        return this.page.secondPage
      }
    },
    fireInitPageTrackingEvent () {
      if (this.initPage !== null) {
        this.$cciEventTrackingPlugin.trackEvent('ContextPageView', 'ActionPagesPageView', initPage.firstPage, initPage.firstPage.attributes.Page)
        if (initPage.secondPage !== null) {
          this.$cciEventTrackingPlugin.trackEvent('ContextPageView', 'ActionPagesPageView', initPage.secondPage, initPage.secondPage.attributes.Page)
        }
        // this.$cciTrackingPlugin.trackPageView(this.$cciTracking, this.initPage)
        this.initPage = null
      }
      window.removeEventListener('mi_micb_loaded', this.fireInitPageTrackingEvent)
    },
    destroyZoomer () {
      if (this.zoomer !== null) {
        this.zoomer.destroy()
        this.zoomer = null
      }
    },
    zoomInFromButton () {
      if (this.page === this.currentPage) {
        var newZoomLevel = this.zoomer.scale
        newZoomLevel += 0.50
        if (newZoomLevel > this.zoomer.zoomMax) {
          newZoomLevel = this.zoomer.zoomMax
        }
        this.trackAnimateZoomEvent = 'ActionPagesPageZoomButtonClickIn'
        this.zoomWithScale(newZoomLevel)
      }
    },
    zoomOutFromButton () {
      if (this.page === this.currentPage) {
        var newZoomLevel = this.zoomer.scale
        newZoomLevel -= 0.50
        if (newZoomLevel < 1.0) {
          newZoomLevel = 1.0
        }
        this.trackAnimateZoomEvent = 'ActionPagesPageZoomButtonClickOut'
        this.zoomWithScale(newZoomLevel)
      }
    },
    zoomWithScale (newZoomLevel) {
      this.zoomChanged = true
      if (newZoomLevel > 1.0) {
        let pageContainer = document.getElementById('pages-container')

        var centerX = pageContainer.clientWidth / 2
        if (this.adsEnabled && this.isDesktop()) {
          // offset with 300 if there's an ad on the left side.
          centerX = (pageContainer.clientWidth / 2) + 300
        }
        let centerY = pageContainer.clientHeight / 2
        this.zoomToLevel(newZoomLevel, centerX, centerY)
      } else if (newZoomLevel <= 1.0) {
        this.zoomToLevel(1.0)
      }
    },
    fireZoomEvent(actionKey) {
      let article = this.getArticleInCenter()
      let roundedScale = Math.floor(this.zoomer.scale * 10) / 10
      if (article !== null) {
        this.$cciEventTrackingPlugin.trackEvent('ContextPageView', actionKey, article, 'scale: ' + roundedScale, roundedScale)
      } else {
        let page = this.getPageInCenter()
        if (page !== undefined) {
          this.$cciEventTrackingPlugin.trackEvent('ContextPageView', actionKey, page, 'scale: ' + roundedScale, roundedScale)
        }
      }
    },
    fullscreenChange () {
      let self = this
      setTimeout(function () {
        self.layoutPages()
      }, 100)
    },
    didPageResize () {
      if (!this.isFullPageViewMode) {
        // TO-DO: re-center page.
      }
    },
    destroyCropper () {
      if (this.cropper !== undefined) {
        enableSwiping()
        this.cropper.destroy()
        this.cropperOnScreen = false
        this.cropper = undefined
      }
    },
    getPageFromId() {
      if (this.pages) {
        for (var i = 0; i < this.pages.length; i++) {
          if (this.pages[i].firstPage.id === this.pageId) {
            return this.pages[i]
          } else if (this.pages[i].secondPage !== null && this.pages[i].secondPage.id === this.pageId) {
            return this.pages[i]
          }
        }
      }
    },
    isPageScrolledToRight() {
      var pageLeftContBoundingRect = document.getElementById(this._uid + 'page-left-container').getBoundingClientRect()
      var pageWrapperBoundingRect = document.getElementById(this._uid + 'page-wrapper').getBoundingClientRect()
      if (pageLeftContBoundingRect.width > pageWrapperBoundingRect.width && pageLeftContBoundingRect.height <= pageWrapperBoundingRect.height) {
        if (parseInt(pageLeftContBoundingRect.right, 10) <= parseInt(pageWrapperBoundingRect.right, 10)) {
          return true
        }
        return false
      }
      return true
    },
    isPageScrolledToLeft() {
      var pageLeftContBoundingRect = document.getElementById(this._uid + 'page-left-container').getBoundingClientRect()
      var pageWrapperBoundingRect = document.getElementById(this._uid + 'page-wrapper').getBoundingClientRect()
      if (pageLeftContBoundingRect.width > pageWrapperBoundingRect.width && pageLeftContBoundingRect.height <= pageWrapperBoundingRect.height) {
        if (parseInt(pageLeftContBoundingRect.left, 10) >= parseInt(pageWrapperBoundingRect.left, 10)) {
          return true
        }
        return false
      }
      return true
    },
    updateShouldScrollToRight(toRight) {
      this.shouldScrollToRight = toRight
      this.shouldScrollToRight ? this.scrollToRight(0) : this.scrollToLeft(0)
    },
    scrollToLeft(time) {
      if (this.zoomer !== null && this.isFullPageViewMode && !this.isPageScrolledToLeft()) {
        if (time === undefined) {
          time = 300
        }
        this.zoomer.scrollToLeft(time)
        return true
      }
      return false
    },
    scrollToRight(time) {
      if (this.zoomer !== null && this.isFullPageViewMode && !this.isPageScrolledToRight()) {
        if (time === undefined) {
          time = 300
        }
        this.zoomer.scrollToRight(time)
        return true
      }
      return false
    }
  },
  beforeDestroy () {
    window.removeEventListener('buttonZoomIn', this.zoomInFromButton)
    window.removeEventListener('buttonZoomOut', this.zoomOutFromButton)

    document.removeEventListener('fullscreenchange', this.fullscreenChange)
    document.removeEventListener('mozfullscreenchange', this.fullscreenChange)
    document.removeEventListener('webkitfullscreenchange', this.fullscreenChange)
    document.removeEventListener('msfullscreenchange', this.fullscreenChange)

    this.destroyCropper()
    this.destroyZoomer()
  },
  components: {
    CciArticleLayer,
    CciClickableAdLayer,
    CciWidgetLayer,
    CciZoomAreaLayer
  }
}
